import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CookieSettingsService } from '../../services/cookie-settings.service';
import { StorageService } from 'src/app/core/services/storage/storage.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cookie-settings-button',
  templateUrl: './cookie-settings-button.component.html',
  styleUrls: ['./cookie-settings-button.component.css']
})
export class CookieSettingsButtonComponent implements OnInit, OnDestroy {
  hasCookieConsent = false;
  isHomePage = false;
  private routerSubscription: Subscription;
  private consentCheckSubscription: Subscription;

  constructor(
    private cookieSettingsService: CookieSettingsService,
    private storageService: StorageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Check initial consent status
    this.checkConsentStatus();

    // Check if current page is home page
    this.checkIfHomePage();

    // Listen to route changes
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkIfHomePage();
      });

    // Listen to modal close to update button visibility
    this.consentCheckSubscription = this.cookieSettingsService.showSettings$.subscribe(show => {
      if (!show) {
        // Modal was closed, recheck consent status
        setTimeout(() => this.checkConsentStatus(), 100);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.consentCheckSubscription) {
      this.consentCheckSubscription.unsubscribe();
    }
  }

  private checkConsentStatus(): void {
    const cookieInfo = this.storageService.getCookie('tresInfo');
    this.hasCookieConsent = cookieInfo.length > 0;
  }

  private checkIfHomePage(): void {
    const currentUrl = this.router.url;
    // Show button only on home page routes
    this.isHomePage = currentUrl === '/' ||
                      currentUrl === '/home' ||
                      currentUrl === '/home-new' ||
                      currentUrl.startsWith('/#') || // For fragment navigation
                      currentUrl.startsWith('/home#') ||
                      currentUrl.startsWith('/home-new#');
  }

  openCookieSettings(): void {
    this.cookieSettingsService.openSettings();
  }
}
